export default "__VITE_ASSET__sSjoVafj__"